import type { CustomerTimelineEntry } from "@repo/app-types/entities/performanceCustomer";
import type { CustomerTimelineRow } from "@repo/ui/customerTimeline/customerTimeline";
import { CustomerTimelineIconNode } from "@repo/ui/customerTimeline/customerTimelineNodes";
import { PH_MASK_CLASS } from "../../analytics/sessionRecordingMasking.js";
import { renderCallEventRow } from "./callEventRow.js";
import { renderCallRow } from "./callRow.js";
import { renderTextConversationRow } from "./textConversationRow.js";
import {
  formatCustomerTimelineTime,
  type CustomerTimelineRowOptions,
  type InteractionRowParts,
} from "./timelineRowHelpers.js";

export function buildCustomerTimelineRowId(
  entry: CustomerTimelineEntry,
): string {
  return `${entry.type}:${entry.id}`;
}

/** The timeline row for an entry. Each kind of entry has its own row file here. */
export function buildCustomerTimelineRow(
  entry: CustomerTimelineEntry,
  options: CustomerTimelineRowOptions,
): CustomerTimelineRow {
  const { icon, details } = renderRowByKind(entry, options);
  return {
    id: buildCustomerTimelineRowId(entry),
    dateTime: entry.at,
    dateLabel: formatCustomerTimelineTime(entry.at),
    node: <CustomerTimelineIconNode icon={icon} />,
    details: <div className={PH_MASK_CLASS}>{details}</div>,
  };
}

function renderRowByKind(
  entry: CustomerTimelineEntry,
  options: CustomerTimelineRowOptions,
): InteractionRowParts {
  switch (entry.type) {
    case "call":
      return renderCallRow(entry, options);
    case "call_event":
      return renderCallEventRow(entry, options);
    case "text_conversation":
      return renderTextConversationRow(entry, options);
  }
}
